/** Short copy for catalog cards and the heading above the purchase controls. */
export const OFFER_SHORT_DESCRIPTION_LIMIT = 200;
/** Cuántas viñetas enseña como mucho la lista «Incluye» de una tarjeta. */
export const OFFER_FEATURES_LIMIT = 8;
/** Una línea que empieza con viñeta: «• Clases ilimitadas», «- Toalla», «✓ Casillero». */
const BULLET_LINE = /^\s*(?:[•·✓✔✅▪◦]\s*|[*\-–—]\s+)(.+?)\s*$/;
/**
 * Lo que incluye una oferta: las líneas con viñeta de su descripción.
 *
 * Las ofertas no tienen un campo de ventajas. Quien vende un plan las escribe
 * en la descripción como lista, y la IA las deja igual al crear un plan
 * (`pricingToCatalog`). De aquí sale el campo «Incluye» de las tarjetas, el que
 * pinta las tablas de planes con los datos de verdad.
 */
export function offerFeatures(description) {
    return description.split('\n')
        .map((line) => BULLET_LINE.exec(line)?.[1] ?? '')
        .filter(Boolean)
        .slice(0, OFFER_FEATURES_LIMIT);
}
/**
 * Older offers keep their full description and get a bounded summary. An explicit empty summary stays empty.
 *
 * Without a summary, the bullet lines stay out of it when there is other text: they are the
 * «Incluye» list (`offerFeatures`), and squashed into one line they read as «… • Toalla • Casillero».
 */
export function offerShortDescription(offer) {
    const source = offer.shortDescription ?? (() => {
        const prose = offer.description.split('\n').filter((line) => !BULLET_LINE.test(line)).join('\n');
        return prose.trim() ? prose : offer.description;
    })();
    const text = source.replace(/\s+/g, ' ').trim();
    if (text.length <= OFFER_SHORT_DESCRIPTION_LIMIT)
        return text;
    const excerpt = text.slice(0, OFFER_SHORT_DESCRIPTION_LIMIT - 1);
    const lastSpace = excerpt.lastIndexOf(' ');
    return `${(lastSpace > OFFER_SHORT_DESCRIPTION_LIMIT / 2 ? excerpt.slice(0, lastSpace) : excerpt).trimEnd()}…`;
}
//# sourceMappingURL=offerDescription.js.map